import { Component, OnInit } from '@angular/core';
import { ClientServiceService } from '../services/client-service.service';
import { Router } from '@angular/router';
import { Profile } from '../models/profile.models';
import { CountryService } from '../services/country.service';
import { Country } from '../models/country.model';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  auth_client_token: any = null;
  profiles: Profile[] | null = null;

  countries: Country[] | [] = [];

  constructor(
    private client_service: ClientServiceService,
    private countryService: CountryService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.auth_client_token = localStorage.getItem("auth_client_token");
    if(!this.auth_client_token) {
      this.router.navigate(["/login"]);
    }
    this.client_service.get_client_profile(this.auth_client_token).subscribe({
      next: (data) => {
        if (data.length === 0) {
          this.router.navigate(["/dashboard"]);
          return;
        }
        this.profiles = data.map((profile: Profile) => ({
          ...profile,
          masked_phone: this.maskPhoneNumber(profile.phone) 
        }));
      },
      error: (err) => {
        // console.log(err);
      }
    })
    this.client_service.get_customer_info(this.auth_client_token).subscribe({
      next: (data) => {
        if (data.status !== 'Active') {
          this.router.navigate(["/dashboard"]);
        }
      },
      error: (err) => {
        // console.log(err);
      }
    });
    this.countryService.getCountries().subscribe({
      next: (data) => {
        this.countries = data;
      },
      error: (err) => {
        // console.error(err);
      }
    });
  }

  translateCountry(country_name: string) {
    const current_country = this.countries.find((c: Country) => c.countryName === country_name);
    return "countries." + current_country?.countryShortCode;
  }

  translateRegion(profile: Profile) {
    const current_country = this.countries.find((c: Country) => c.countryName === profile.country);
    return "regions." + current_country?.countryShortCode + "." + profile.state_region;
  }

  toggleShowPhone(profile: Profile) {
    if (profile?.phone === profile?.masked_phone) {
      profile.masked_phone = this.maskPhoneNumber(profile.phone);
    } else {
      profile.masked_phone = profile.phone;
    }
  }

  maskPhoneNumber(phone: string | undefined): string {
    if (phone) {
      if (phone.length < 3) return phone;
      if (phone.length === 3) return phone.slice(0, 2) + '*';
      if (phone.length <= 6) return phone.slice(0, 2) + '*'.repeat(phone.length - 2);
      const first = phone.slice(0, 2);
      const last = phone.slice(6);
      const masked = '****';
      return first + masked + last;
    } else {
      return "";
    }
  }

  downloadAgreement(event: Event, profile: Profile) {
    event.preventDefault();
    this.client_service.download_profile_pdf(this.auth_client_token, profile.email).subscribe({
      next: (data: Blob) => {
        const url = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        link.download = `agreement_${profile?.first_name}_${profile?.last_name}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      },
      error: (err) => {
        // console.error('Error downloading PDF:', err);
      }
    });
  }
}
